export const listSVGIcon05 = {}
